import { createSuitMixin as e } from "../mixins/suit.js";
import { isVue2 as t, isVue3 as i } from "../util/vue-compat/index-vue2.js";
import { createWidgetMixin as o } from "../mixins/widget.js";
import { connectSearchBox as s } from "instantsearch.js/es/connectors/index.js";
import u from "./SearchInput.vue.js";
export default {
  name: "AisSearchBox",
  mixins: [o({
    connector: s
  }, {
    $$widgetType: "ais.searchBox"
  }), e({
    name: "SearchBox"
  })],
  components: {
    SearchInput: u
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    showLoadingIndicator: {
      type: Boolean,
      default: !0
    },
    ignoreCompositionEvents: {
      type: Boolean,
      default: !1
    },
    submitTitle: {
      type: String,
      default: "Submit the search query"
    },
    resetTitle: {
      type: String,
      default: "Clear the search query"
    },
    value: {
      type: String,
      default: void 0
    },
    modelValue: {
      type: String,
      default: void 0
    },
    queryHook: {
      type: Function,
      default: void 0
    }
  },
  data: function data() {
    return {
      localValue: "",
      isVue2: t,
      isVue3: i
    };
  },
  computed: {
    widgetParams: function widgetParams() {
      return {
        queryHook: this.queryHook
      };
    },
    isControlled: function isControlled() {
      return void 0 !== this.value || void 0 !== this.modelValue;
    },
    model: function model() {
      return this.value || this.modelValue;
    },
    currentRefinement: {
      get: function get() {
        this.isControlled && this.model !== this.localValue && (this.localValue = this.model, this.$emit("input", this.model), this.$emit("update:modelValue", this.model), this.state.refine(this.model));
        var e = this.$refs.searchInput;
        return e && e.isFocused() ? this.localValue : this.model || this.state.query || "";
      },
      set: function set(e) {
        this.localValue = e, this.state.refine(e), this.isControlled && (this.$emit("input", e), this.$emit("update:modelValue", e));
      }
    }
  }
};